// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const oliveTree = defineModel({
  id: "olive-tree",
  batchId: "future",
  name: "Olive tree",
  tags: ["scenery","olive","tree","low-poly","age-of-mcp","future"],
  summary: "An olive tree. Pressed for cooking and lamp oil, soap and lubricant; the fruit is food.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.06, 0.11, 0.34, 6), color: "#7a6e5a", position: [0.02, 0.17, 0], rotation: [0, 0, 0.08] },
      { geometry: new THREE.IcosahedronGeometry(0.22, 0), color: "#8a9b76", position: [-0.12, 0.46, 0.04], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#9aa886", position: [0.16, 0.5, -0.06], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#8a9b76", position: [0.04, 0.6, 0.12], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#3a4a2a", position: [-0.2, 0.44, 0.1] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.06, 0.11, 0.34, 6), color: "#7a6e5a", position: [0.02, 0.17, 0], rotation: [0, 0, 0.08] },
      { geometry: new THREE.IcosahedronGeometry(0.22, 0), color: "#8a9b76", position: [-0.12, 0.46, 0.04], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#9aa886", position: [0.16, 0.5, -0.06], scale: [1.1, 0.85, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#8a9b76", position: [0.04, 0.6, 0.12], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#3a4a2a", position: [0.2, 0.44, 0.1] },
    ] },
  ],
  animations: [],
});
